import * as THREE from 'three'
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader.js'
const baseURL = 'https://resources.roche-bobois.com'
export const SetHDRI = (scene, renderer) => {
  const pmremGenerator = new THREE.PMREMGenerator(renderer)
  pmremGenerator.compileEquirectangularShader()
  new RGBELoader().load(`${baseURL}/corail/assets/abandoned_hall_01_1k_Desat.hdr`, texture => {
    texture.encoding = THREE.RGBEEncoding
    texture.minFilter = THREE.NearestFilter
    texture.magFilter = THREE.NearestFilter
    const envMap = pmremGenerator.fromEquirectangular(texture).texture
    pmremGenerator.compileCubemapShader()
    scene.environment = envMap
    texture.dispose()
    pmremGenerator.dispose()
  })
}
